export default __webpack_public_path__ + "static/media/click3.b38967d2.mp3";